module.exports = __webpack_public_path__ + "static/media/dhobikhana1.57ec623c.ogg";